import { cloneDeep } from 'lodash-es';
import I18n from '@/rI18n';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';


export const validateErrorTicket = (argsCommon, itemField) => {
    if (Utils.isEmptyArray(argsCommon.fieldListData)) {
        return true;
    }

    let itemFieldObj;
    try {
        itemFieldObj = JSON.parse(itemField);
    } catch (err) {
        console.log('validateErrorTicket error ', err);
        return true;
    }

    let fieldList = cloneDeep(argsCommon.fieldListData);

    let isValidateError = false;
    // validate
    fieldList.forEach(field => {
        let isCheck = field.definition !== 'SYSTEM' && field.type === Constant.FORM_TYPE.FIELD_TAG
            && (!Utils.isEmpty(field.structure.required) && field.structure.required);
        if (isCheck) {
            isValidateError = Utils.isEmptyObject(itemFieldObj)
                || Utils.isEmptyArray(itemFieldObj.tagField[`${field.id}`]);
            field.error = {
                isError: isValidateError,
                message: isValidateError ? I18n.get('COMM01MSG11') : ''
            }
        }
    });

    if (isValidateError) {
        argsCommon.setFiledListData(fieldList);
    }
    return isValidateError;
};

//validate max size kbs;
export const validateExceedSizeOfFieldTicket = (
    fieldListData,
    setFiledListData,
    listFields
) => {
    if (Utils.isEmptyObject(listFields)) return;

    let itemFieldObj = Utils.convertJSONDataToObject(listFields);
    let fieldList = cloneDeep(fieldListData);

    let isValidateError = false;
    for (let field of fieldList) {
        if (field.type === Constant.FORM_TYPE.HTML) continue;

        let fieldValue = itemFieldObj[field.id];
        if (field.type === Constant.FORM_TYPE.FIELD_RICHTEXT) {
            fieldValue = JSON.stringify(fieldValue)
        }

        let errorMessage = Utils.validateSizeOfFieldTicket(fieldValue);
        if (errorMessage) {
            isValidateError = true;
            field.error = {
                isError: isValidateError,
                message: errorMessage
            };
        }
    }

    if (isValidateError) {
        setFiledListData(fieldList);
    }

    return isValidateError;
};